import React, { useEffect, useState } from 'react';

import './dateSelect.scss';
import Select from '../inputs/Select';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import AuditTrail from "../../services/interactions/audit.trail";

function DateSelect({ event, value, onChange, asNumber, required, error }) {
    let currentYear = (new Date()).getFullYear();
    const {t} = useTranslation(['users'])
    const maxYear = currentYear;
    const minYear = 1910;
    const [dateBlock, setDateBlock] = useState({ day: '', month: '', year: '' });
    useEffect(() => {
        console.log('Value Date select: ', value);
        if (!!value) {
            const _value = asNumber ? new Date(value) : value;
            const year = _value.getFullYear();
            const month = _value.getMonth();
            const day = _value.getDate();
            setDateBlock({
                day, month, year
            })
        }
    }, [value, asNumber]);

    const clearDay = () => {
        if (!dateBlock['day']) {
            onChange(null);
        }else{
            const { year, month, day } = dateBlock;
            AuditTrail.sendLog(event, {tag: 'input', event: 'onChange', action: 'input date select', day: day});
            if (year && (month || month === 0) && (day || day === 0)) {
                const _date = new Date(year, month, day);
                if (asNumber) {
                    onChange(_date.getTime());
                } else {
                    onChange(_date);
                }
            } else {
                onChange(null);
            }
        }
    };

    const clearYear = () => {
        const valueString = `${dateBlock['year']}`;
        AuditTrail.sendLog(event, {tag: 'input', event: 'onChange', action: 'input date select', year: valueString});
        if (valueString.length === 4) {
            let _year = parseInt(valueString);
            if (_year < minYear) {
                dateBlock['year'] = minYear;
            }
        }
        if (valueString.length > 4) {
            dateBlock['year'] = parseInt(valueString.substring(0, 4));
        }
        if (dateBlock['year'] > currentYear) {
            dateBlock['year'] = currentYear;
            const { year, month, day } = dateBlock;
            setDateBlock(Object.assign({}, dateBlock));
            if ((!!year || year === 0) && (month || month === 0) && (day || day === 0) && onChange) {
                const _date = new Date(year, month, day);
                if (asNumber) {
                    console.log('CHanging date to: ', _date.getTime());
                    onChange(_date.getTime());
                } else {
                    console.log('CHanging date to: ', _date);
                    onChange(_date);
                }
            }
        } else if (parseInt(dateBlock['year']) < minYear) {
            const { year } = dateBlock;
            let _year = parseInt(year);
            dateBlock['year'] = _year;
            setDateBlock(Object.assign({}, dateBlock));
            // WHY change to empty?
            console.log("CHanging date to: empty value");
            onChange(null);
        } else {
            const { year, month, day } = dateBlock;
            let _year = parseInt(year);
            setDateBlock(Object.assign({}, dateBlock));
            if ((!!_year || _year === 0) && (!!month || month === 0) && (day || day === 0) && onChange) {
                const _date = new Date(_year, month, day);
                if (asNumber) {
                    console.log('CHanging date to: ', _date.getTime());
                    onChange(_date.getTime());
                } else {
                    console.log('CHanging date to: ', _date);
                    onChange(_date);
                }
            } else {
                console.log("CHanging date to: empty value");
                onChange(null);
            }
        }
    };

    const changeDate = (propety) => {
        return (e) => {
            if (e === null) {
                dateBlock[propety] = e;
                setDateBlock(Object.assign({}, dateBlock));
                clearYear();
                return;
            }
            let value = typeof e === 'number' ? e : e.target.value;
            if (propety === 'day') {
                if (value !== "") {
                    value = value < 1 ? 1 : value;
                    const maxDays = moment(new Date(dateBlock.year, dateBlock.month, 1).getTime()).daysInMonth();
                    if (value > maxDays) {
                        value = maxDays;
                    }
                }
            } else if (propety === 'month') {
                value = value < 0 ? 0 : value;
                const maxDays = moment(new Date(dateBlock.year, value, 1).getTime()).daysInMonth();
                if (dateBlock.day > maxDays) {
                    dateBlock.day = maxDays;
                }
            } else if (propety === 'year') {
                value = value > (new Date().getFullYear()) ? value : value;
                const maxDays = moment(new Date(value, dateBlock.month, 1).getTime()).daysInMonth();
                if (dateBlock.day > maxDays) {
                    dateBlock.day = maxDays;
                }
            }
            dateBlock[propety] = value;
            const { year, month, day } = dateBlock;
            setDateBlock(Object.assign({}, dateBlock));
            if ((year >= minYear) && (month || month === 0) && (day || day === 0) && onChange) {
                const _date = new Date(year, month, day);
                if (asNumber) {
                    console.log('CHanging date to: ', _date.getTime());
                    onChange(_date.getTime());
                } else {
                    console.log('CHanging date to: ', _date);
                    onChange(_date);
                }
            } else {
                clearYear();
            }
        }
    }
    const monthOptions = [
        { label: '--', value: null },
        { label: t('months.jan'), value: 0 },
        { label: t('months.feb'), value: 1 },
        { label: t('months.mar'), value: 2 },
        { label: t('months.apr'), value: 3 },
        { label: t('months.may'), value: 4 },
        { label: t('months.jun'), value: 5 },
        { label: t('months.jul'), value: 6 },
        { label: t('months.aug'), value: 7 },
        { label: t('months.sep'), value: 8 },
        { label: t('months.oct'), value: 9 },
        { label: t('months.nov'), value: 10 },
        { label: t('months.dec'), value: 11 },
    ]
    const hasError = () => {
        const hasDate = dateBlock.day || dateBlock.day === 0 || dateBlock.month || dateBlock.month === 0 || dateBlock.year;
        return required || hasDate? error : !!value && error;
    }
    return (
        <div className={`__DateSelect ${hasError() ? 'error' : ''}`}>
            <label>{t('date-of-birth')} {required ? <span className="__req">*</span> : ''}</label>
            <input type="number" value={dateBlock.day} onChange={changeDate('day')} onBlur={clearDay} placeholder="DD" />
            <Select error={hasError()} value={dateBlock.month} onChange={changeDate('month')} placeholder="MM" options={monthOptions} event={event}/>
            <input type="number" value={dateBlock.year} onChange={changeDate('year')} onBlur={clearYear} placeholder="YYYY" min={minYear} max={maxYear} />
            <div className="__selectOverlap"></div>
        </div>
    )
}

export default DateSelect;
